import { createContext } from 'react';
export const MenuContext = /*#__PURE__*/createContext({
  getItemProps: () => ({}),
  getFloatingProps: () => ({}),
  getReferenceProps: () => ({}),
  activeIndex: null,
  setActiveIndex: () => void 0,
  isOpen: false,
  setIsOpen: () => void 0,
  isChildOpen: false,
  setIsChildOpen: () => void 0,
  nodeId: 'INIT',
  refs: null,
  context: null,
  floatingStyles: {},
  listRef: null,
  labelsRef: null,
  level: 0,
  virtualItemRef: null
});